<template>
  <footer>
    <p class="copyright">SINCE 2013 © LanCul Co., Ltd. All Rights Reserved.</p>
  </footer>
</template>

<script>

export default {
  name: 'Footer'
}
</script>

<style scoped>
footer {
  width: 100%;
  height: 60px;
  padding: 20px 0;
  background-color: #efefef;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin-top: auto;
}

footer .copyright {
  color: black;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
}

@media (max-width: 337px) {
  footer .copyright {
    font-size: 11px;
    line-height: 16.5px;
  }
}
</style>
